import { Word } from 'widgets/ChartWidgets/WordCloud/WordCloud.types';

const fixedValueGenerator = () => 0.5;

const getRotationDegree = () => {
  const rand = Math.random();
  const degree = rand > 0.5 ? 60 : -60;
  return rand * degree;
};

const getWordCloudData = (listText: (string | number)[], listValues: (string | number)[], colors: string[]) => {
  const merged: Word[] = [];
  let colorIndex = 0;
  listText.forEach((text, i) => {
    if (listValues[i] && text) {
      if (colorIndex < colors.length - 1) {
        colorIndex++;
      } else {
        colorIndex = 0;
      }
      const valueAsNumber = Number(listValues[i]);
      merged.push({
        text: String(text),
        value: isNaN(valueAsNumber) ? 1 : Math.max(valueAsNumber, 1),
        color: colors[colorIndex] ?? '#000000',
      });
    }
  });
  return merged;
};

export { fixedValueGenerator, getWordCloudData, getRotationDegree };
